import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';
import packageJson from '../../package.json';
import { isEmailCleanable, cleanEmail, convertAppVersionToReadable } from '../utils/Utilities';
import { GetUser, UpdateUser } from '../isdlData/matrixUserData';
import { ThemeContext } from '../contexts/AppContext';
import { LightbulbOn, LightbulbOff } from '../icons/Icons';
import { useAppStateService } from '../contexts/AppState';
import { GetBallTests } from '../isdlData/constantsData';

const winAppDlUrlDEV = "https://isdlappsdev.blob.core.windows.net/lmreceiver/Mobile/WINDOWS/LMReceiver.appinstaller";
const winAppDlUrlPROD = "https://isdlapps.blob.core.windows.net/lmreceiver/Mobile/WINDOWS/LMReceiver.appinstaller";
const iosAppDlUrlDEV = "itms-services:///?action=download-manifest&amp;url=https://isdlappsdev.blob.core.windows.net/lmreceiver/Mobile/IOS/LMReceiver.plist";
const iosAppDlUrlPROD = "itms-services:///?action=download-manifest&amp;url=https://isdlapps.blob.core.windows.net/lmreceiver/Mobile/IOS/LMReceiver.plist";

const isIOS = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (/iPad|iPhone|iPod/.test(ua)) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

function Portal({ OnModalSwitch, OnLogout = () => Promise.resolve() }){

    const [subHeaderText, setSubHeaderText] = useState("WEB: " + convertAppVersionToReadable(packageJson.version));
    const [appSubHeaderText, setAppSubHeaderText] = useState("APP: No App Detected");
    const [validDC, setValidDC] = useState(false);
    const [dataCollector, setDataCollector] = useState(null);
    const [needUpdate, setNeedUpdate] = useState(false);
    const [openAppShowing,setOpenAppShowing] = useState(false);
    const [userLookupStatus, setUserLookupStatus] = useState('loading');

    const appDownloadURL = "";

    const appState = useAppStateService();

    const { theme, setAppTheme } = useContext(ThemeContext);
    
    const [isAnalyst, setIsAnalyst] = useState(false);

    useEffect(() =>{
        if(packageJson.buildType === "PROD"){
            setSubHeaderText("WEB: " + convertAppVersionToReadable(packageJson.version));

            if(appState.InApp){
                setAppSubHeaderText("APP: " + appState.AppVersion);
            }else{
                setAppSubHeaderText("APP: No App Detected");
            }

        }else{
            setSubHeaderText("WEB: " + convertAppVersionToReadable(packageJson.version) + " " + packageJson.buildType);

             if(appState.InApp){
                setAppSubHeaderText("APP: " + appState.AppVersion + " " + appState.AppEnvironment);
            }else{
                setAppSubHeaderText("APP: No App Detected");
            }
        }

        GetBallTests();

        const loadDCData = async () =>{
                const dcemail = sessionStorage.getItem('dataCollectorEmail');
                setUserLookupStatus('loading');
        
                if(dcemail && isEmailCleanable(dcemail)){
                    const cleanedEmail = cleanEmail(dcemail);
        
                    const userData = await GetUser(cleanedEmail.toLowerCase());

                    //userData["Role"] = "DataCollector";
                    // userData["FirstName"] = "Nick";
                    // userData["LastName"] = "Drexl";
                    // userData["FullName"] = "Nick Drexl";

                    // await UpdateUser(userData);

                    if(!userData){
                        setDataCollector(null);
                        sessionStorage.removeItem('dataCollectorRole');
                        setValidDC(false);
                        setIsAnalyst(false);
                        setUserLookupStatus('not_found');
                        return;
                    }

                    setDataCollector(userData);
                    sessionStorage.setItem('dataCollectorRole', userData.Role);
                    if(userData && (userData.Role === "Admin" || userData.Role === "DataCollector")){
                        setValidDC(true);
                        setIsAnalyst(false);
                    }else if(userData && userData.Role === "Analyst"){
                        setValidDC(false);
                        setIsAnalyst(true);
                    }else{
                        setValidDC(false);
                        setIsAnalyst(false);
                    }
                    setUserLookupStatus('found');
                }else{
                    setDataCollector(null);
                    setValidDC(false);
                    setIsAnalyst(false);
                    sessionStorage.removeItem('dataCollectorRole');
                    setUserLookupStatus('not_found');
                }
            }

        loadDCData();
    }, []);

    useEffect(() => {
        setNeedUpdate(false);
        if(appState.InApp){
            if(appState.AppEnvironment === "DEV"){
                setAppSubHeaderText("APP: " + appState.AppVersion + " " + appState.AppEnvironment);
            }else{
                setAppSubHeaderText("APP: " + appState.AppVersion);
            }

            if(appState.AppVersion !== convertAppVersionToReadable(packageJson.version)){
                setNeedUpdate(true);
            }
        }else{
            setAppSubHeaderText("APP: No App Detected");
        }
    }, [appState.InApp, appState.AppVersion, appState.AppEnvironment]);

    const handlePortalClick = async (option) => {
        switch(option){
            case "STARTSESSION":
                OnModalSwitch(null, "START");
                break;
            case "NEWTASK":
                OnModalSwitch(null, "TASKMAN");
                break;
            case "LOADSESSION":
                OnModalSwitch(dataCollector, "EXISTINGSESSION");
                break;
            case "LOGOUT":
                await OnLogout();
                break;
            case "UPDATE":
                if(isIOS()){
                    if(appState.AppEnvironment === "DEV"){
                        window.open(iosAppDlUrlDEV, "_blank");
                    }else{
                        window.open(iosAppDlUrlPROD, "_blank");
                    }
                }else{
                    if(appState.AppEnvironment === "DEV"){
                        window.open(winAppDlUrlDEV, "_blank");
                    }else{
                        window.open(winAppDlUrlPROD, "_blank");
                    }
                }
                break;
            case "OPENAPP":
                break;
        }
    }

    const handleThemeToggle = () => {
        setAppTheme(theme === 'dark' ? 'light' : 'dark');
    }

    const logoutLabel = userLookupStatus === 'loading'
        ? 'Log Out - Loading User Info...'
        : userLookupStatus === 'not_found'
            ? 'Log Out - NO USER FOUND'
            : `Log Out - ${dataCollector?.FullName} (${dataCollector?.id}) [${dataCollector?.Role}]`;

    const disableLoadSession = userLookupStatus !== 'found';

    return (
        <div>
            <div className='portal-background' style={{backgroundImage: `url("/ecpc_bg3.png")`}}/>
            <button className='portal-theme-button' onClick={handleThemeToggle} title={theme === 'light' ? 'Turn on dark mode' : 'Turn on light mode'}>
                {(theme === 'light' ? (
                    <LightbulbOff width='40px' height='40px'/>
                ): (
                    <LightbulbOn width='40px' height='40px'/>
                ))}
            </button>
            <div style={{display:'flex', position:'fixed', width:'100%', height:'100%', flexDirection:'column', justifyContent:'start', pointerEvents:'none'}}>
                <div className='portal-header'>LM Receiver</div>
                <div className='portal-subheader'>{subHeaderText}</div>
                <div className='portal-subheader'>{appSubHeaderText}</div>
            </div>
            <div className='portal'>
                <div className='portal-content'>
                    {needUpdate && (
                        <button id="updateAppButton" className='portal-button update' onClick={() => handlePortalClick("UPDATE")}>Update App</button>
                    )}
                    {openAppShowing && (
                        <button id="newTaskButton" className='portal-button' onClick={() => handlePortalClick("OPENAPP")}>Open App</button>
                    )}
                    {!isAnalyst && (
                        <button id="newTaskButton" className='portal-button' disabled={!validDC} onClick={() => handlePortalClick("NEWTASK")}>New Task</button>
                    )}
                    <button id="loadSessionButton" className='portal-button' disabled={disableLoadSession} onClick={() => handlePortalClick("LOADSESSION")}>Load Session</button>
                </div>
                <button id="logoutButton" className='portal-button-subtler' style={{ marginRight: 'auto' }}   onClick={() => handlePortalClick("LOGOUT")}>{logoutLabel}</button>
                
                {!isAnalyst && (
                    <button id="manualEntryButton" className='portal-button-subtle' disabled={!validDC} onClick={() => handlePortalClick("STARTSESSION")}>Manual Entry</button>
                )}
            </div>
        </div>
    );
}

export default Portal;
